import { format } from "date-fns";

const toValidDate = (value) => {
  if (value === null || value === undefined || value === "") return null;
  try {
    const d = value instanceof Date ? value : new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  } catch (_e) {
    return null;
  }
};

/**
 * Slovak date format: DD.MM.YYYY
 */
export const formatDateSk = (value, fallback = "—") => {
  const d = toValidDate(value);
  if (!d) return fallback;
  return format(d, "dd.MM.yyyy");
};

/**
 * Slovak date+time format: DD.MM.YYYY HH:mm
 */
export const formatDateTimeSk = (value, fallback = "—") => {
  const d = toValidDate(value);
  if (!d) return fallback;
  return format(d, "dd.MM.yyyy HH:mm");
};

/**
 * Slovak date+time format with seconds: DD.MM.YYYY HH:mm:ss
 */
export const formatDateTimeSecondsSk = (value, fallback = "—") => {
  const d = toValidDate(value);
  if (!d) return fallback;
  return format(d, "dd.MM.yyyy HH:mm:ss");
};

